import { render, staticRenderFns } from "./SubscriptionOrders.vue?vue&type=template&id=cc2a30a2&"
import script from "./SubscriptionOrders.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionOrders.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports